export const MEDIA_QUERY_HEADER = 'mobile';
export const PADDING_TOP_LOGO = '28px';
